import CryptoJS from 'crypto-js';

import env from '#env';

export const setSessionStorageItem = (key, value) => {
    const encrypted = CryptoJS.AES.encrypt(JSON.stringify(value), env.VITE_ENCRYPTED_KEY).toString();
    sessionStorage.setItem(key, encrypted);
};

export const getSessionStorageItem = (key, defaultValue = null) => {
    const encrypted = sessionStorage.getItem(key);
    if (!encrypted) return defaultValue;
    try {
        const bytes = CryptoJS.AES.decrypt(encrypted, env.VITE_ENCRYPTED_KEY);
        const decrypted = bytes.toString(CryptoJS.enc.Utf8);
        return decrypted ? JSON.parse(decrypted) : defaultValue;
    } catch (e) {
        console.error('Failed to decrypt sessionStorage key', key, e);
        return defaultValue;
    }
};

export const removeSessionStorageItem = key => sessionStorage.removeItem(key);

export const clearSessionStorage = () => sessionStorage.clear();
